module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAICAYAAADJEc7MAAAAzUlEQVQoU32QPRIBQRCFX+9MrtRupqzMEYQkYqmSiTkEJZUSOYFyAFdQpVxi/URGSMDOU7Os36WT7nmvv+qpJ8VANTzKEPciwOeYTB9vriITt8U5JV+NCXRS+HfnzsJWNgbbBASgQ1/NAdT/wCfCq63Neel2UhBhDnlqbyGQcgZMEq31IZ6m3gN0QiFAWVEtAOTfYOEg2tveq/YGOiP0dZ3kXAT6vjiLTNx8CSmRv8BbWF6XkBHA1cXY6g44fn4/E0wuB7pveZm4BLMCuwIaGUULjjYSqAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/order/ico_other.png
// module id = //pX
// module chunks = 0